/**
 * Rounds to at most `maxDecimals` places and drops trailing zeros — 80.0000
 * reads as 80, 5.000 as 5, 0.3100 as 0.31.
 *
 * Materials and recipe lines come back from Postgres as fixed-precision
 * decimal strings (`unit_cost` is `DECIMAL(10,4)`, `percentage` is
 * `DECIMAL(6,3)`), which is exactly the precision worth keeping in storage
 * and arithmetic — not what an owner wants to read on a screen.
 */
export const trimmedDecimal = (value, maxDecimals) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";

  const fixed = num.toFixed(maxDecimals);
  return fixed.includes(".")
    ? fixed.replace(/0+$/, "").replace(/\.$/, "")
    : fixed;
};
